var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSendTicketWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_ticket",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 34,
    height: 34,
    transform: "translate(1073 652)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_50",
    "data-name": "Mask Group 50",
    transform: "translate(-1073 -652)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_paper-plane_",
    "data-name": "FontAwsome (paper-plane)",
    d: "M17.256.278.981,9.664A1.878,1.878,0,0,0,1.2,13.024l4.472,1.85v3.3A1.88,1.88,0,0,0,9.063,19.3l1.714-2.312,4.378,1.807a1.882,1.882,0,0,0,2.574-1.451L20.053,2.191a1.881,1.881,0,0,0-2.8-1.913Zm-9.7,17.9V15.649l1.432.591Zm8.317-1.123L9.854,14.569l5.485-7.914a.627.627,0,0,0-.927-.829l-8.274,7.21L1.92,11.291,18.195,1.9Z",
    transform: "translate(1079.94 658.96)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendTicketWhite);
export default __webpack_public_path__ + "static/media/icon_send_ticket_white.3468ae38d7241803bb03f0a389546c3e.svg";
export { ForwardRef as ReactComponent };